
import { LocalStorageConsts } from 'client/util/Constants';
import { defineComponent } from 'vue';
import { useMfaLabels } from 'client/util/Constants/MfaLabels';
import DuoRedirectView from 'client/containers/user/Views/DuoRedirectView.vue';
import LocalStorageService from 'client/util/LocalStorageService';
import Util from 'client/util/Util';

const { userPwdResetInfo, userPwdResetMeta } = LocalStorageConsts;

export default defineComponent({
  name: 'DuoUserResetPasswordRedirectHandler',

  components: {
    DuoRedirectView,
  },

  setup() {
    const uiLabel = useMfaLabels();
    return { uiLabel };
  },

  data() {
    return {
      isLoading: false,
    };
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    requestKey: {
      type: String,
      required: true,
    },
    resetTemplate: {
      type: String,
      default: 'resetPasswordUserMfaDirect',
    },
    controllingQueryParams: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    handleDuoRedirect(): void {
      try {
        this.$emit('resetErrorMessage');
        this.isLoading = true;

        Util.redirect(this.form.challenge.duo.location);
        // Add pwd reset data here so it's available when Duo
        // redirects back to /login/duo/oauth/callback
        // See DuoCallbackHandler.vue
        const { context, redirectTo } = this.controllingQueryParams as {
          context?: string;
          redirectTo?: string;
        };
        const isLegacyEmailLink = this.resetTemplate === 'resetPasswordUserForm'
          && Boolean(this.form.password || this.form.confirm);
        LocalStorageService.setItem(userPwdResetInfo, JSON.stringify({
          ...(isLegacyEmailLink ? {
            confirm: this.form.confirm,
            password: this.form.password,
          } : {}),
          pwdResetToken: this.form.pwdResetToken,
          requestKey: this.requestKey,
        }));
        LocalStorageService.setItem(userPwdResetMeta, JSON.stringify({
          resetTemplate: this.resetTemplate,
          ...(context && redirectTo ? { context, redirectTo } : {}),
        }));
      } catch {
        this.$emit('error', this.uiLabel.duo.error.redirect);
        this.isLoading = false;
      }
    },
  },
});
